module.exports = __webpack_public_path__ + "media/abk/assets/images/event-placeholder-b8e9200953614f492123e1aafbf56384.jpg";